export default __webpack_public_path__ + "static/media/banner-city.217924ff.png";